import React from 'react';
import MuiAlert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

/**
 * Custom Alert component wrapping MUI Alert.
 * Use for error, warning, info, and success messages across the app.
 *
 * @param {string} severity - 'error' | 'warning' | 'info' | 'success'
 * @param {string} [message] - Main message text
 * @param {string} [title] - Optional title above the message
 * @param {React.ReactNode} [action] - Optional action (e.g. Retry button)
 * @param {function} [onClose] - If provided, alert is dismissible
 * @param {React.ReactNode} [children] - Extra content below the message (e.g. tips list)
 * @param {object} [sx] - MUI sx prop for styling
 * @param {string} [className] - Optional CSS class
 */
const Alert = ({
  severity = 'info',
  message,
  title,
  action,
  onClose,
  children,
  sx,
  className,
  ...rest
}) => {
  return (
    <MuiAlert
      severity={severity}
      onClose={onClose}
      action={action}
      className={className}
      sx={{ mb: 2, ...sx }}
      {...rest}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
      {children}
    </MuiAlert>
  );
};

export default Alert;
